'use client';

import type { ReactNode } from 'react';
import { useMemo, useState } from 'react';

import { SnackbarContext } from './context';
import { SnackbarContainer } from './SnackbarContainer';
import type { ContainerProps, SnackbarProps } from './types';

function SnackbarContextProvider({ children }: { children: ReactNode }) {
  const [snackbar, setSnackbar] = useState<SnackbarProps | null>(null);
  const value = useMemo(() => {
    return {
      snackbar,
      onAdd: (v: SnackbarProps) => setSnackbar(v),
      onDelete: () => setSnackbar(null),
    };
  }, [snackbar]);

  return (
    <SnackbarContext.Provider value={value}>
      {children}
    </SnackbarContext.Provider>
  );
}

export function SnackbarProvider({
  children,
  containerProps,
}: {
  children: ReactNode;
  containerProps?: ContainerProps;
}) {
  return (
    <SnackbarContextProvider>
      {children}
      <SnackbarContainer {...containerProps} />
    </SnackbarContextProvider>
  );
}
